export default __webpack_public_path__ + "static/media/wwf_mobile@2x.2f7ef356.jpg";